import { Modelo } from '@ext/index';
import * as Types from './Envio.types';
import moment ,{ Moment } from 'moment';
import { ITransporte } from '../../Expedicion/Transportes/Transporte.lib';
import { Transporte } from '../../Expedicion/Transportes';

export class IEnvio extends Modelo {

    public constructor( Json: any = null ) {
        super( Json );
        if ( Json )
            this.set();
    }
    public Id: number = 0;
    public IdExterna: number = 0;
    public Cuenta: string = '';
    public Etiqueta: string = '';
    public Plataforma: Types.Plataformas = Types.Plataformas.Propia;
    public Tipo: Types.Tipos = Types.Tipos.NoEspecificado;
    public Estado: Types.Estados = Types.Estados.Creado;
    public EstadoPlataforma: string = '';
    public EmpresaLogistica: ITransporte = new ITransporte();

    public Importes: Importes = {
        Cliente: 0,
        Base: 0,
        Propio: 0,
        Bonificado: 0,
        Descuentos: 0,
    };

    public CodigoRetiro: string = '';
    public CodigoQr: string = '';



    public Fechas: Fechas = {
        Creacion: moment( '' ),
        Edicion: moment( '' ),
        Cancelacion: moment( '' ),
        Recibido: moment( '' ),
        PrimeraVisita: moment( '' ),
        Preparacion: moment( '' ),
        Enviado: moment( '' ),
        Retornado: moment( '' ),
        EnvioEstimado: moment( '' )
    };


    public Tracking: Tracking = {
        Codigo: '',
        Metodo: '',
        Retorno: '',
    };

    public NumeroGuia: number = 0;

    public Direccion: Direccion = new Direccion();

    public get Demorado(): boolean {
        if ( this.Fechas.EnvioEstimado.isValid() ) {
            return this.Fechas.EnvioEstimado.isBefore( moment().add(-1,'day') )
        }
        return false;
    }

    public get Urgente(): boolean {
        if ( this.Fechas.EnvioEstimado.isValid() && !this.Demorado ) {
            return this.Fechas.EnvioEstimado.isToday();
        }
        return false;
    }

    public getJson(): any {
        let json: any = {};
        json.id = this.Id;
        json.id_externa = this.IdExterna;
        json.cuenta = this.Cuenta ? this.Cuenta : null;
        json.etiqueta = this.Etiqueta;
        json.plataforma = this.Plataforma.Id;
        json.tipo = this.Tipo.Id;
        json.estado = this.Estado.Id;
        json.estado_plataforma = this.EstadoPlataforma;
        json.empresa_logistica = this.EmpresaLogistica.Codigo;


        json.importe = this.Importes.Propio;
        json.importe_base = this.Importes.Base;
        json.importe_bonificado = this.Importes.Bonificado;
        json.descuento = this.Importes.Descuentos;

        json.codigo_retiro = this.CodigoRetiro;
        json.codigo_qr = this.CodigoQr;
        json.importe_cliente = this.Importes.Cliente;
        json.fecha_creacion = this.Fechas.Creacion.toSQL();
        json.fecha_edicion = this.Fechas.Edicion.toSQL();
        json.fecha_cancelacion = this.Fechas.Cancelacion.toSQL();
        json.fecha_recibido = this.Fechas.Recibido.toSQL();
        json.fecha_primera_visita = this.Fechas.PrimeraVisita.toSQL();
        json.fecha_preparacion = this.Fechas.Preparacion.toSQL();
        json.fecha_enviado = this.Fechas.Enviado.toSQL();
        json.fecha_retornado = this.Fechas.Retornado.toSQL();
        json.fecha_envio_estimado = this.Fechas.EnvioEstimado.toSQL();
        json.tracking_codigo = this.Tracking.Codigo;
        json.tracking_retorno_codigo = this.Tracking.Retorno;
        json.tracking_metodo = this.Tracking.Metodo;


        json.numero_guia = this.NumeroGuia;

        json.recibe = this.Direccion.Recibe;
        json.documento = this.Direccion.Documento;
        json.horario_desde = this.Direccion.HorarioDesde.toSQL();
        json.horario_hasta = this.Direccion.HorarioHasta.toSQL();
        json.calle = this.Direccion.Calle;
        json.numero = this.Direccion.Numero;
        json.departamento = this.Direccion.Departamento;
        json.piso = this.Direccion.Piso;
        json.comentario = this.Direccion.Comentario;
        json.entre_calles = this.Direccion.EntreCalles;
        json.barrio = this.Direccion.Barrio;
        json.localidad = this.Direccion.Localidad;
        json.codigo_postal = this.Direccion.CodigoPostal;
        json.provincia = this.Direccion.Provincia;
        json.pais = this.Direccion.Pais;
        json.latitud = this.Direccion.Latitud;
        json.longitud = this.Direccion.Longitud;
        json.telefono = this.Direccion.Telefono;
        json.celular = this.Direccion.Celular;
        json.email = this.Direccion.Email;

        return json;
    }

    public set(): boolean {


        this.Id = !this.Json.id ? 0 : this.Json.id;
        this.IdExterna = !this.Json.id_externa ? 0 : this.Json.id_externa;

        this.Cuenta = !this.Json.cuenta ? '' : this.Json.cuenta;
        this.Etiqueta = !this.Json.etiqueta ? null : this.Json.etiqueta;

        this.Plataforma = !this.Json.plataforma ? Types.Plataformas.Propia : Types.Plataformas.toTipo( this.Json.plataforma );
        this.Tipo = !this.Json.tipo ? Types.Tipos.NoEspecificado : Types.Tipos.toTipo( this.Json.tipo );

        this.Estado = !this.Json.estado ? Types.Estados.Creado : Types.Estados.toTipo( this.Json.estado );
        this.EstadoPlataforma = !this.Json.estado_plataforma ? '' : this.Json.estado_plataforma;

        this.Importes.Propio = !this.Json.importe ? 0 : this.Json.importe;
        this.Importes.Cliente = !this.Json.importe_cliente ? 0 : this.Json.importe_cliente;
        this.Importes.Bonificado = !this.Json.importe_bonificado ? 0 : this.Json.importe_bonificado;
        this.Importes.Descuentos = !this.Json.descuento ? 0 : this.Json.descuento;
        this.Importes.Base = !this.Json.importe_base ? 0 : this.Json.importe_base;

        this.CodigoRetiro = !this.Json.codigo_retiro ? '' : this.Json.codigo_retiro;
        this.CodigoQr = !this.Json.codigo_qr ? '' : this.Json.codigo_qr;

        this.Fechas.Creacion = !this.Json.fecha_creacion ? moment( '' ) : moment( this.Json.fecha_creacion );
        this.Fechas.Edicion = !this.Json.fecha_edicion ? moment( '' ) : moment( this.Json.fecha_edicion );
        this.Fechas.Cancelacion = !this.Json.fecha_cancelacion ? moment( '' ) : moment( this.Json.fecha_cancelacion );
        this.Fechas.Recibido = !this.Json.fecha_recibido ? moment( '' ) : moment( this.Json.fecha_recibido );
        this.Fechas.PrimeraVisita = !this.Json.fecha_primera_visita ? moment( '' ) : moment( this.Json.fecha_primera_visita );
        this.Fechas.Preparacion = !this.Json.fecha_preparacion ? moment( '' ) : moment( this.Json.fecha_preparacion );
        this.Fechas.Enviado = !this.Json.fecha_enviado ? moment( '' ) : moment( this.Json.fecha_enviado );
        this.Fechas.Retornado = !this.Json.fecha_retornado ? moment( '' ) : moment( this.Json.fecha_retornado );
        this.Fechas.EnvioEstimado = !this.Json.fecha_envio_estimado ? moment( '' ) : moment( this.Json.fecha_envio_estimado );

        this.Tracking.Codigo = !this.Json.tracking_codigo ? '' : this.Json.tracking_codigo;
        this.Tracking.Retorno = !this.Json.tracking_retorno_codigo ? '' : this.Json.tracking_retorno_codigo;
        this.Tracking.Metodo = !this.Json.tracking_metodo ? '' : this.Json.tracking_metodo;

        this.NumeroGuia = !this.Json.numero_guia ? 0 : this.Json.numero_guia;

        this.Direccion.Recibe = !this.Json.recibe ? '' : this.Json.recibe;
        this.Direccion.Documento = !this.Json.documento ? '' : this.Json.documento;
        this.Direccion.HorarioDesde = !this.Json.horario_desde ? moment( '' ) : moment( this.Json.horario_desde );
        this.Direccion.HorarioHasta = !this.Json.horario_hasta ? moment( '' ) : moment( this.Json.horario_hasta );
        this.Direccion.Calle = !this.Json.calle ? '' : this.Json.calle;
        this.Direccion.Numero = !this.Json.numero ? '' : this.Json.numero;
        this.Direccion.Departamento = !this.Json.departamento ? '' : this.Json.departamento;
        this.Direccion.Piso = !this.Json.piso ? '' : this.Json.piso;
        this.Direccion.Comentario = !this.Json.comentario ? '' : this.Json.comentario;
        this.Direccion.EntreCalles = !this.Json.entre_calles ? '' : this.Json.entre_calles;
        this.Direccion.Barrio = !this.Json.barrio ? '' : this.Json.barrio;
        this.Direccion.Localidad = !this.Json.localidad ? '' : this.Json.localidad;
        this.Direccion.CodigoPostal = !this.Json.codigo_postal ? '' : this.Json.codigo_postal;
        this.Direccion.Provincia = !this.Json.provincia ? '' : this.Json.provincia;
        this.Direccion.Pais = !this.Json.pais ? '' : this.Json.pais;
        this.Direccion.Latitud = !this.Json.latitud ? 0 : this.Json.latitud;
        this.Direccion.Longitud = !this.Json.longitud ? 0 : this.Json.longitud;
        this.Direccion.Telefono = !this.Json.telefono ? '' : this.Json.telefono;
        this.Direccion.Celular = !this.Json.celular ? '' : this.Json.celular;
        this.Direccion.Email = !this.Json.email ? '' : this.Json.email;

        if ( this.Json.empresa_logistica ) {
            this.EmpresaLogistica = new Transporte( this.Json.empresa_logistica );
        }

        this.Existe = true;
        return this.Existe;
    }

    public get Vista(): Vista {
        return new Vista( this );
    }
}

class Vista {
    constructor( Model: IEnvio ) {
        this.Model = Model;
    }

    public Model: IEnvio;

}


type Importes = {
    Propio: number,
    Base: number,
    Cliente: number,
    Bonificado: number,
    Descuentos: number,
};

type Tracking = {
    Codigo: string,
    Retorno: string,
    Metodo: string;
};

type Fechas = {
    Creacion: Moment,
    Edicion: Moment,
    Cancelacion: Moment,
    Recibido: Moment,
    PrimeraVisita: Moment,
    Preparacion: Moment,
    Enviado: Moment,
    Retornado: Moment,
    EnvioEstimado: Moment;
};

class Direccion {

    public Recibe: string = '';
    public Documento: string = '';
    public HorarioDesde: Moment = moment( '' );
    public HorarioHasta: Moment = moment( '' );
    public Calle: string = '';
    public Numero: string = '';
    public Departamento: string = '';
    public Piso: string = '';
    public Comentario: string = '';
    public EntreCalles: string = '';
    public Barrio: string = '';
    public Localidad: string = '';
    public CodigoPostal: string = '';
    public Provincia: string = '';
    public Pais: string = '';
    public Latitud: number = 0;
    public Longitud: number = 0;
    public Telefono: string = '';
    public Celular: string = '';
    public Email: string = '';

    public get Linea(): string {
        return this.Calle + ' ' + this.Numero + ' ' + this.Piso + this.Departamento + ' ' + this.Localidad + ' ' + this.CodigoPostal + ' ' + this.Provincia;
    }

    public get Valida(): boolean {
        let e = !this.Calle || !this.Localidad || !this.CodigoPostal || !this.Provincia;
        return !e;
    }
}